import { render, staticRenderFns } from "./SalesmanIcon.vue?vue&type=template&id=d854f098&scoped=true&"
import script from "./SalesmanIcon.vue?vue&type=script&lang=js&"
export * from "./SalesmanIcon.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "d854f098",
  null
  ,true
)

export default component.exports